import { RouteConfig } from 'vue-router'

import classMatcSystemIconActive from '../assets/images/icon_menu_class_match_active@2x.png'
import classMatcSystemIconInactive from '../assets/images/icon_menu_class_match_inactive@2x.png'

const Layout = () => import('../views/Layout.vue')
const LayoutEmpty = () => import('../views/LayoutEmpty.vue')
const MatchCalendarIndex = () => import('../views/class-match-system/match-calendar/Index.vue')
const LeagueManagementIndex = () => import('../views/class-match-system/league-management/league-list/Index.vue')
const LeagueManagementCreate = () =>
  import('../views/class-match-system/league-management/create-league/CreateLeague.vue')
const LeagueManagementDetail = () =>
  import('../views/class-match-system/league-management/league-detail/LeagueDetail.vue')
const LeagueCvcStatStudents = () =>
  import('../views/class-match-system/league-management/league-detail/CvcStatStudentsPage.vue')
const LeagueCvcStatStudentRecords = () =>
  import('../views/class-match-system/league-management/league-detail/CvcStatStudentRecordsPage.vue')
const JudgeManagementJudge = () => import('../views/class-match-system/judge-management/Judge.vue')
const JudgeManagementTask = () => import('../views/class-match-system/judge-management/Task.vue')
const DeviceManagementIndex = () => import('../views/class-match-system/device-management/Index.vue')
const DeviceControlIndex = () => import('../views/class-match-system/device-management/device-control/Index.vue')
const VenueManagementIndex = () => import('../views/class-match-system/venue-management/Index.vue')
const TeamManagementIndex = () => import('../views/class-match-system/team-management/Index.vue')
const TeamManagementCreate = () => import('../views/class-match-system/team-management/CreateTeam.vue')

export const matchCalendarRoute: RouteConfig = {
  path: '/class-match-system/match-calendar',
  name: 'class_match_system_match_calendar',
  component: MatchCalendarIndex,
  meta: {
    title: '赛事日历',
    showMenu: true,
  },
}

export const leagueManagementListRedirectRoute: RouteConfig = {
  path: '/class-match-system/league-management',
  redirect: '/class-match-system/league-management/league-list',
}

export const leagueManagementRoute: RouteConfig = {
  path: '/class-match-system/league-management/league-list',
  name: 'class_match_system_league_management',
  component: LeagueManagementIndex,
  meta: {
    title: '联赛管理',
    showMenu: true,
  },
}

export const leagueManagementCreateRoute: RouteConfig = {
  path: '/class-match-system/league-management/create',
  name: 'class_match_system_league_create',
  component: LeagueManagementCreate,
  meta: {
    title: '创建班级超级联赛',
    showMenu: false,
    activeMenu: 'class_match_system_league_management',
  },
}

export const leagueManagementDetailRoute: RouteConfig = {
  path: '/class-match-system/league-management/detail',
  name: 'class_match_system_league_detail',
  component: LeagueManagementDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '联赛详情',
    showMenu: false,
    activeMenu: 'class_match_system_league_management',
  },
}

export const leagueCvcStatStudentsRoute: RouteConfig = {
  path: '/class-match-system/league-management/cvc-stat-students',
  name: 'class_match_system_league_cvc_stat_students',
  component: LeagueCvcStatStudents,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生列表',
    showMenu: false,
    activeMenu: 'class_match_system_league_management',
  },
}

export const leagueCvcStatStudentRecordsRoute: RouteConfig = {
  path: '/class-match-system/league-management/cvc-stat-student-records',
  name: 'class_match_system_league_cvc_stat_student_records',
  component: LeagueCvcStatStudentRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生明细',
    showMenu: false,
    activeMenu: 'class_match_system_league_management',
  },
}

export const judgeManagementRoute: RouteConfig = {
  path: '/class-match-system/judge-management',
  name: 'class_match_system_judge_management',
  component: LayoutEmpty,
  redirect: '/class-match-system/judge-management/judge',
  meta: {
    title: '裁判管理',
    showMenu: true,
  },
  children: [
    {
      path: 'judge',
      name: 'class_match_system_judge_management_judge',
      component: JudgeManagementJudge,
      meta: {
        title: '裁判列表',
        showMenu: true,
      },
    },
    {
      path: 'event-judge',
      name: 'class_match_system_judge_management_event_judge',
      component: JudgeManagementTask,
      meta: {
        title: '任务列表',
        showMenu: true,
      },
    },
  ],
}

export const venueManagementRoute: RouteConfig = {
  path: '/class-match-system/venue-management',
  name: 'class_match_system_venue_management',
  component: VenueManagementIndex,
  meta: {
    title: '场地管理',
    showMenu: true,
  },
}

export const teamManagementRoute: RouteConfig = {
  path: '/class-match-system/team-management',
  name: 'class_match_system_team_management',
  component: TeamManagementIndex,
  meta: {
    title: '队伍管理',
    showMenu: true,
  },
}

export const teamManagementCreateRoute: RouteConfig = {
  path: '/class-match-system/team-management/create/:teamId?',
  name: 'class_match_system_team_create',
  component: TeamManagementCreate,
  meta: {
    title: '新建队伍',
    showMenu: false,
  },
}

export const deviceManagementRoute: RouteConfig = {
  path: '/class-match-system/device-management',
  name: 'class_match_system_device_management',
  component: DeviceManagementIndex,
  meta: {
    title: '设备管理',
    showMenu: true,
  },
}

export const deviceControlRoute: RouteConfig = {
  path: '/class-match-system/device-management/control',
  name: 'class_match_system_device_control',
  component: DeviceControlIndex,
  meta: {
    title: '设备管控',
    showMenu: false,
    activeMenu: 'class_match_system_device_management',
  },
}

export default [
  {
    path: '/class-match-system',
    name: 'class_match_system',
    component: Layout,
    redirect: '/class-match-system/league-management/league-list',
    meta: {
      title: '班级超级联赛',
      icon: classMatcSystemIconInactive,
      iconActive: classMatcSystemIconActive,
      showMenu: true,
    },
    children: [
      matchCalendarRoute,
      leagueManagementListRedirectRoute,
      leagueManagementRoute,
      leagueManagementCreateRoute,
      leagueManagementDetailRoute,
      leagueCvcStatStudentsRoute,
      leagueCvcStatStudentRecordsRoute,
      teamManagementRoute,
      teamManagementCreateRoute,
      venueManagementRoute,
      judgeManagementRoute,
      deviceManagementRoute,
      deviceControlRoute,
    ],
  },
]
